// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media(min-width: 992px){.gGI6gGsEDenB1y3dvZPR>div{max-width:560px}}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/notifications/ui/Options/styles.module.scss"],"names":[],"mappings":"AAII,yBADF,0BAEI,eAAA,CAAA","sourcesContent":["@import 'app/styles/breakpoints';\n\n.toggleItem {\n  & > div {\n    @media (min-width: $breakpoint-s) {\n      max-width: 560px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggleItem": `gGI6gGsEDenB1y3dvZPR`
};
export default ___CSS_LOADER_EXPORT___;
